<template>
    <div>
        <v-card class="mt-6 pa-3" color="#eee" ref="cardq">
            <v-row>
                <v-col cols="12" sm="12">
                    <v-row>
                        <v-btn @click="$emit('deleted', tid)" class="ml-6 mt-3" color="error">刪除</v-btn>
                        <span class="ml-3 mt-6">{{q_index}}.</span>
                        <v-text-field v-model="title" @change="update" single-line="" class="input_400 ml-3" label="請輸入問題描述"></v-text-field>
                        <v-btn @click="edit_header_click" class="ml-3 mt-3" color="primary">選項設定</v-btn>
                        <v-btn @click="edit_question_click" class="ml-3 mt-3" color="primary">問題設定</v-btn>
                    </v-row>
                    <v-row v-for="(t, idx1) in title_list" :key="idx1" class='ml-3 pl-12'>
                        <v-col cols="12" sm="12">
                            <v-row>
                                <v-textarea v-model="t.title" @change="update" single-line="" class="input_400 ml-9" label="請輸入問題描述" outlined></v-textarea>
                                <!-- <v-text-field v-model="t.title" @change="update" single-line="" class="input_400 ml-9" label="請輸入問題描述"></v-text-field> -->

                                <v-btn @click="delete_title(idx1)" class="ml-3 mt-3" text icon color="error">
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                            </v-row>
                        </v-col>
                        <v-data-table :headers="[]" :items="description_list" disable-pagination hide-default-footer hide-default-header="" class="elevation-1 ml-12">
                            <template v-slot:item="{item}">
                                <tr v-if="item.headers_id!==0" style="text-align: center;">
                                    <td style="text-align: left; min-width: 200px;">{{item.title}}</td>
                                    <td v-for="(v, idx2) in headers_list[headers_list.findIndex(e=> e.id==item.headers_id)].headers" :key="'h'+idx1+'_'+idx2">
                                        <input type="radio" :name="'h'+idx1" disabled/> {{v.title}}
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-row>

                    <v-row v-if="!add_descr_flag" class="ml-3 pl-12">
                        <v-btn @click="add_descr_flag=true" class="ml-12 mt-3" color="primary">新增子問題</v-btn>
                    </v-row>
                    <v-row v-else class="pl-12">
                        <v-textarea v-model="title_input" single-line="" class="input_400 ml-12" label="請輸入子問題" outlined></v-textarea>
                        <v-btn @click="add_descr(); add_descr_flag=false; update()" class="ml-3 mt-3" color="success">儲存</v-btn>
                    </v-row>
                </v-col>
            </v-row>
        </v-card>

        <!-- 子問題設定 -->
        <v-dialog v-model="edit_question_dialog" width="600" persistent scrollable>
            <v-card style="overflow: hidden;">
                <v-card-title class="headline grey lighten-2">問題設定
                    <v-spacer/>
                    <v-icon @click="edit_question_dialog=false">mdi-close</v-icon>
                </v-card-title>
                <v-card-text class="pl-12 mt-3">
                    <v-row v-for="(q, idx) in edit_description_list" :key="'q'+idx">
                        <v-text-field v-model="q.title"  single-line="" class="input_360" label="請輸入問題"></v-text-field>
                        <v-select v-model="q.headers_id"  :items="headers_list" item-text="title" item-value="id" placeholder="請選擇選項類別" class="input_240 ml-3" outlined></v-select>
                        <v-btn @click="delete_question(q)" class="ml-3 mt-3" text icon color="error">
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                    </v-row>
                    <v-row>
                        <v-btn color="primary" @click="add_question">新增問題</v-btn>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pl-6 pr-6" justify="center">
                    <v-row justify="center">
                        <v-btn color="success" @click="edit_question_sbumit" block>送出</v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- 選項設定 -->
        <v-dialog v-model="edit_header_dialog" max-width="1800px" persistent scrollable>
            <v-card style="overflow: hidden;">
                <v-card-title class="headline grey lighten-2">選項設定
                    <v-spacer/>
                    <v-icon @click="edit_header_dialog=false">mdi-close</v-icon>
                </v-card-title>
                <v-card-text class="pl-12">
                    <v-row v-for="(lheaders, idx) in edit_header_list" :key="idx">
                        <v-col cols="12" sm="12">
                            <v-row>
                                <h3 class="mt-6">第{{idx+1}}組:</h3>
                                <v-text-field v-model="lheaders.title" placeholder="尚未設定" single-line class="input_120 ml-3"></v-text-field>
                                <v-btn @click="delete_choice(lheaders.id)" class="ml-3 mt-3" text icon color="error">
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="12">
                            <v-row>
                                <span v-for="(h, idx2) in lheaders.headers" :key="'h'+idx2">
                                    <v-text-field v-model="h.title" placeholder="選項內容" single-line solo class="input_90 ml-3"></v-text-field>
                                </span>
                            </v-row>
                            <v-row>
                                <span v-for="(h, idx2) in lheaders.headers" :key="'h'+idx2">
                                    <v-text-field v-model="h.score" placeholder="選項分數" single-line solo class="input_90 ml-3"></v-text-field>
                                </span>
                            </v-row>
                        </v-col>
                        <!-- <v-col v-for="(h, idx2) in lheaders.headers" :key="'h'+idx2" cols="12" sm="2" md='2' lg='1' xl='1'>
                            <v-text-field v-model="h.title" placeholder="選項內容" single-line solo class="input_120"></v-text-field>
                            <v-text-field v-model="h.score" placeholder="選項分數" single-line solo class="input_120"></v-text-field>
                        </v-col> -->
                    </v-row>
                    <v-divider></v-divider>
                    <v-row v-if="!add_choice_flag">
                        <v-btn @click="add_choice_flag=true" class="ml-3 mt-3" color="primary">新增選項</v-btn>
                    </v-row>
                    <v-row v-else>
                        <v-select v-model="num" :items="[3, 5, 7]" placeholder="請選擇級距" class="input_240 mt-3" outlined></v-select>
                        <v-btn @click="add_choice" class="ml-3 mt-6" color="success">確認</v-btn>
                    </v-row>

                </v-card-text>
                <v-card-actions class="pl-6 pr-6" justify="center">
                    <v-row justify="center">
                        <v-btn color="success" @click="edit_header_submit" block>送出</v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

</template>

<script>
import bus from '../../nav/bus'

export default {
    props: {
        tid: {
            type: Number,
            default: -1,
        },
        index: {
            type: Number,
            default: -1,
        },
        question: {
            type: Object,
            default: function(){
                return {
                    title: '',
                    headers_list: [],
                    title_list: [],
                    description_list: [],
                }
            }
        }
    },
    data(){
        return{
            q_index: -1,
            edit_header_dialog: false,
            edit_question_dialog: false,
            add_choice_flag: false,

            title: '',
            headers_list: [],
            title_list: [],
            description_list: [],
            num: -1,
            select_space: -1,

            add_descr_flag: false,
            title_input: '',

            edit_description_list: [],
            edit_header_list: [],
        }
    },
    watch:{
        index: function(val){
            this.q_index = val
        },
        question: function(val){
            this.construct()
        }
    },
    mounted(){
        this.construct()
    },
    methods:{
        delete_title(idx){
            this.title_list.splice(idx, 1)
        },
        edit_header_submit(){
            // 檢查是否有空白
            let check = false
            let check_header_duplicate = []
            for(let k of this.edit_header_list){
                if(check_header_duplicate.indexOf(k.title) == -1){
                    check_header_duplicate.push(k.title)
                }
                else{
                    bus.$emit('alert', {msg: '選項標題不可重複！', title: "提示",　check: "我知道了"})
                    return
                }
                if(k.title == ''){
                    check = true
                    break
                }
                let check_duplicate = []
                for(let l of k.headers){
                    if(check_duplicate.indexOf(l.title) == -1)
                        check_duplicate.push(l.title)
                    else{
                        bus.$emit('alert', {msg: '選項內容不可重複！', title: "提示",　check: "我知道了"})
                        return
                    }
                    if(l.title == '' || String(l.score) == ''){
                        check = true
                    }
                }
                if(check)
                    break
            }
            if(check){
                bus.$emit('alert', {msg: '選項標題 內容 分數不可以空白喔！ 請您再確認！', title: "提示",　check: "我知道了"})
                return
            }

            this.headers_list = this.edit_header_list
            this.edit_header_dialog=false
            this.update()
        },
        edit_header_click(){
            this.edit_header_list = JSON.parse(JSON.stringify(this.headers_list))
            this.edit_header_dialog=true
        },
        edit_question_sbumit(){
            // 檢查是否有空白
            let check = false
            for(let k of this.edit_description_list){
                if(k.title == '' || k.headers_id == 0){
                    bus.$emit('alert', {msg: '子問題 選項類別不可以空白喔！ 請您再確認！', title: "提示",　check: "我知道了"})
                    return
                }
            }
            this.description_list = this.edit_description_list
            this.edit_question_dialog=false
            this.update()
        },
        edit_question_click(){
            this.edit_description_list = JSON.parse(JSON.stringify(this.description_list))
            this.edit_question_dialog=true
        },
        add_descr(){
            if(this.title_list.findIndex(e=>e.title==this.title_input) != -1){
                bus.$emit('alert', {msg: '子問題不可重複！', title: "提示",　check: "我知道了"})
                    return
            }

            this.title_list.push({title: this.title_input,
                                  id: (this.title_list.length+1)*-1})
            this.title_input = ''
        },
        construct(){
            this.q_index = this.index
            this.title = this.question.title
            this.headers_list = this.question.headers_list
            this.title_list = this.question.title_list
            this.description_list = this.question.description_list
        },
        delete_choice(id){
            for(let k of this.description_list)
                if(k.headers_id == id){
                    bus.$emit('alert', {msg: '刪除此選項前 請先確認沒有子問題選用此選項！', title: "提示",　check: "我知道了"})
                    return
                }
            this.edit_header_list.splice(this.edit_header_list.findIndex(e=>e.id==id), 1)
        },
        delete_question(item){
            console.log(item)
            console.log(this.edit_description_list)
            this.edit_description_list.splice(this.edit_description_list.findIndex(e=>e.id==item.id), 1)
        },
        add_choice(){
            if([3,5,7].indexOf(this.num) == -1){
                bus.$emit('alert', {msg: '尚未選擇級距！', title: "提示",　check: "我知道了"})
                return
            }
            let tmp = []
            while(tmp.length<this.num){
                let num1 = tmp.length+1
                // tmp.push({'title': '選項'+num1, score: String(num1)})
                tmp.push({'title': '', score: ''})
            }
            this.edit_header_list.push({
                title: '',
                headers: tmp,
                id: (this.edit_header_list.length+1)*-1
            })
            this.num = -1
            this.add_choice_flag=false;
        },
        add_question(){
            // this.edit_description_list.push({id: (this.description_list.length+1)*-1, title: '', headers_id: 0})
            this.edit_description_list.push({id: (this.edit_description_list.length+1)*-1,
                                             title: '',
                                             headers_id: 0})
        },
        update(){
            this.$emit('update', [
                this.tid,
                {
                    title: this.title,
                    headers_list: this.headers_list,
                    title_list: this.title_list,
                    description_list: this.description_list
                }
            ])
        },
    },
}
</script>

<style lang="scss" scoped>

::v-deep .input_360{
    max-width: 360px;
}

::v-deep .input_90{
    max-width: 90px;
}

::v-deep .input_120{
    max-width: 120px;
}

::v-deep .input_240{
    max-width: 240px;
}

</style>
